import React from 'react';
import Draggable from 'react-draggable';
import { ModalDialog } from 'react-bootstrap';

const DraggableModalDialog = (props) => {
  return <Draggable handle=".modal-header"><ModalDialog {...props} /></Draggable>
}

export default (DraggableModalDialog)